import { createStyles } from "antd-style";

const useAppStyles = createStyles(({ token, css }) => {
  return {
    layout: css`
      width: 100%;
      height: 100vh;
      border-radius: ${token.borderRadius}px;
      display: flex;
      background: ${token.colorBgContainer};
      font-family: AlibabaPuHuiTi, ${token.fontFamily}, sans-serif;
      overflow: hidden;
      
      @media (max-width: 768px) {
        flex-direction: column;
      }

      .ant-prompts {
        color: ${token.colorText};
      }
    `,
    menu: css`
      background: ${token.colorBgLayout}80;
      width: 280px;
      height: 100%;
      display: flex;
      flex-direction: column;
      
      @media (max-width: 768px) {
        display: none;
      }
    `,
    mobileHeader: css`
      display: none;
      padding: 12px;
      background: ${token.colorBgContainer};
      border-bottom: 1px solid ${token.colorBorderSecondary};
      
      @media (max-width: 768px) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    `,
    drawerMenu: css`
      .ant-drawer-body {
        padding: 0;
      }
    `,
    conversations: css`
      padding: 0 12px;
      flex: 1;
      overflow-y: auto;
    `,
    chat: css`
      height: 100%;
      width: 100%;
      max-width: 100%;
      margin: 0 auto;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      padding: ${token.paddingLG}px;
      gap: 16px;
      
      @media (max-width: 768px) {
        padding: ${token.paddingSM}px;
        height: calc(100% - 56px);
      }
      
      @media (min-width: 769px) {
        max-width: 700px;
      }
    `,
    messages: css`
      flex: 1;
      overflow-y: auto;
    `,
    placeholder: css`
      padding-top: 32px;
      
      @media (max-width: 768px) {
        padding-top: 16px;
      }
    `,
    sender: css`
      box-shadow: ${token.boxShadow};
    `,
    logo: css`
      display: flex;
      height: 72px;
      align-items: center;
      justify-content: start;
      padding: 0 24px;
      box-sizing: border-box;

      img {
        width: 24px;
        height: 24px;
        display: inline-block;
      }

      span {
        display: inline-block;
        margin: 0 8px;
        font-weight: bold;
        color: ${token.colorText};
        font-size: 16px;
      }
    `,
    mobileLogo: css`
      display: flex;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
        display: inline-block;
      }

      span {
        display: inline-block;
        margin: 0 8px;
        font-weight: bold;
        color: ${token.colorText};
        font-size: 16px;
      }
    `,
    addBtn: css`
      background: #1677ff0f;
      border: 1px solid #1677ff34;
      width: calc(100% - 24px);
      margin: 0 12px 24px 12px;
    `,
    userForm: css`
      background: ${token.colorBgContainer};
      border-radius: ${token.borderRadius}px;
      padding: 24px;
      box-shadow: ${token.boxShadowSecondary};
      margin-bottom: 16px;
      width: 90%;
      margin-left: auto;
      margin-right: auto;
    `,
    formTitle: css`
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 16px;
      text-align: center;
    `,
    footerTip: css`
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100vw;
      background: rgba(255,255,255,0.85);
      color: #888;
      text-align: center;
      font-size: 14px;
      padding: 8px 0 6px 0;
      z-index: 100;
      pointer-events: none;
      box-shadow: 0 -2px 8px rgba(0,0,0,0.03);
      @media (max-width: 768px) {
        font-size: 12px;
        padding: 6px 0 4px 0;
      }
    `,
  };
});

export default useAppStyles;